import React from "react";
import {  Typography,message,App } from "antd";
import DashboardView from "./DashboardView";


const Dashboard = () => {

  return (
    <DashboardView/>
  );
};

export default Dashboard;
